module.exports = __webpack_public_path__ + "img/Dantam Hair 27.8ed41d43.jpg";